interface ChipOption {
  value: string;
  label: string;
  count?: number;
}

interface Props {
  label: string;
  options: ChipOption[];
  value: string[]; // selected values
  onToggle: (v: string) => void;
}

export function ChipGroup({ label, options, value, onToggle }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="text-[10px] uppercase tracking-[0.08em] font-semibold text-(--color-ink-3)">
        {label}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {options.map((opt) => {
          const active = value.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onToggle(opt.value)}
              className={`chip inline-flex items-center gap-1 px-2.5 py-1 rounded-full font-medium text-[12px] border ${
                active
                  ? "bg-(--color-ink) border-(--color-ink) text-(--color-paper)"
                  : "bg-(--color-paper) border-(--color-line) text-(--color-ink-2) hover:border-(--color-ink-3) hover:text-(--color-ink)"
              }`}
            >
              {opt.label}
              {opt.count !== undefined && (
                <span className={`font-mono text-[11px] ${active ? "opacity-80" : "opacity-60"}`}>
                  {opt.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
